import { render, staticRenderFns } from "./DialogAddress.vue?vue&type=template&id=5716e38e&scoped=true"
import script from "./DialogAddress.vue?vue&type=script&lang=js"
export * from "./DialogAddress.vue?vue&type=script&lang=js"
import style0 from "./DialogAddress.vue?vue&type=style&index=0&id=5716e38e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716e38e",
  null
  
)

export default component.exports